export default {
    topics: [
        {
            title: ' Deploy ',
            href: 'sm-offerCategory-Deploy.html',
            attributes: { 'data-id': 'sm-offerCategory-Deploy' },
            menu: { hasChildren: false },
            tocID: 'sm-offerCategory-Deploy-d66e3341',
            topics: [],
        },
        {
            title: ' GetAccessInfo ',
            href: 'sm-offerCategory-GetAccessInfo.html',
            attributes: { 'data-id': 'sm-offerCategory-GetAccessInfo' },
            menu: { hasChildren: false },
            tocID: 'sm-offerCategory-GetAccessInfo-d66e3349',
            topics: [],
        },
        {
            title: ' GoLive ',
            href: 'sm-offerCategory-GoLive.html',
            attributes: { 'data-id': 'sm-offerCategory-GoLive' },
            menu: { hasChildren: false },
            tocID: 'sm-offerCategory-GoLive-d66e3357',
            topics: [],
        },
    ],
};

